import React, { useState, useEffect } from 'react'
import api from '../../API/api'
import Swal from 'sweetalert2';
import Button from 'react-bootstrap/esm/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import FormDialog from '../panel/modal';


const UsersList = (props) => {
    const [Affiliation, setAffiliation] = useState();
    const [open, setOpen] = React.useState(false);

    const [all, setAll] = useState();


    useEffect(() => {
        getAffiliations();
    }, [])

    const handleClickOpen = () => {
        setOpen(true)
    }

    const getAffiliations = () => {
        api.getAffiliations().then((res) => {
            // console.log(res);
            setAll(res.data.affiliations)
        })
            .catch((err) => {
                // console.log(err);
            })
    }

    const saveAffiliation = () => {
        if (!Affiliation) {
            props.handleClose();
            Swal.fire({
                title: 'Opps!',
                text: 'Please Enter Affiliation!',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return;
        }

        api.saveAffiliation(Affiliation).then((res) => {
            // console.log(res);
            props.handleClose();
            Swal.fire({
                title: 'Success!',
                text: 'Added Succeffully !',
                icon: 'success',
                confirmButtonText: 'Ok'
            })
            getAffiliations();
        })
            .catch((err) => {
                // console.log(err);
            })
    }





    return (
        <>
            <FormDialog form={<UserAddForm />} title='Add User' open={open}  />
            <Button variant='contained' className='float-end m-2' onClick={handleClickOpen}>+Add Users</Button>
            <hr />
            <div className='mt-4 pt-3'>

                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow className='bg-warning'>
                                <TableCell>sl.</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Achievement</TableCell>
                                <TableCell>Short Description</TableCell>
                                <TableCell>Student</TableCell>
                                <TableCell>Image</TableCell>
                                <TableCell align="right">Date</TableCell>
                                <TableCell align="right">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {all?.map((row, index) => (
                                <TableRow
                                    key={index + 1}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        {index + 1}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.user_name}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.title}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.short_desc}
                                    </TableCell>

                                    <TableCell component="th" scope="row">
                                        {row.user_name}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {/* {row.image} */}
                                        <img src={`${process.env.REACT_APP_BACKEND}assets/achiement/${row.image}`} style={{ height: 40 }} />
                                    </TableCell>
                                    <TableCell align="right">{row.date}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

            </div>



        </>
    )
}

export default UsersList;

const UserAddForm = ({}) => {
    return (
        
        <div>
            <div className="row">
                <div className="col-12 m-2">
                    <label htmlFor="">User Name</label>
                    {/* <input type="text" className='form-control' name="affiliation" onChange={(e) => setAffiliation(e.target.value)} id="" placeholder='Enter Affiliation name' /> */}
                </div>

                <div className="col-12 m-2 text-center">
                    <button className='btn btn-success' >+ Add New User </button>
                </div>
            </div>
        </div>
    )
}